import { PassStat, PassResults, PassResult } from "../../api/EvalWorkflowApi";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import i18n from "i18next";
import Button from "reactstrap/lib/Button";
import * as React from "react";

type EvalPassResultProps = {
  result: PassResults;
  onClose: () => void;
};

function EvalPassResult({ result, onClose }: EvalPassResultProps) {
  function displayResultBlock(passResult: PassResult) {
    if (passResult.globalStat.falsePositive === 1 || passResult.globalStat.falseNegative === 1) {
      return (
        <>
          <div style={{ color: "red" }}>
            <i className="fa fa-2x fa-times-rectangle" />
          </div>
          <div>
            {Object.entries(passResult.statByObsType).map(([obsType, passStat]) => (
              <div key={obsType}>
                {passStat.falsePositive === 1 && (
                  <span>
                    {obsType} : {i18n.t("global.falsePositive")}
                  </span>
                )}
                {passStat.falseNegative === 1 && (
                  <span>
                    {obsType} : {i18n.t("global.falseNegative")}
                  </span>
                )}
              </div>
            ))}
          </div>
        </>
      );
    }
    return (
      <div style={{ color: "green" }}>
        <i className="fa fa-2x fa-check-square" />
      </div>
    );
  }

  return (
    <Modal isOpen size="lg">
      <ModalHeader>{i18n.t("global.result")}</ModalHeader>
      <ModalBody className="row">
        <div className="col-sm-4 text-center">
          <h2>{i18n.t("evalPassResult.reader")}</h2>
          <div>{displayResultBlock(result.readerWithoutAiStat)}</div>
        </div>
        <div className="col-sm-4 text-center">
          <h2>{i18n.t("evalPassResult.readerAI")}</h2> {displayResultBlock(result.readerWithAiStat)}
        </div>
        <div className="col-sm-4 text-center">
          <h2>{i18n.t("evalPassResult.AI")}</h2> {displayResultBlock(result.gleamerAiStat)}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => onClose()}>
          {i18n.t("global.next")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default React.memo(EvalPassResult);
